export class EmpCat {
    id?: number;
    empresaID = 0;
    categoriaID = 0;
}